import { Route, Routes } from 'react-router-dom'
import {
  PAGE_USER_MGMT,
  PAGE_DASHBOARD,
  PAGE_LOGIN,
  PAGE_MASTER_DATA,
  PAGE_BUNDLE_PRODUCT,
  PAGE_NOT_FOUND,
  PAGE_FUNC_JOBS,
  PAGE_STORE_MGMT,
  PAGE_ERP_API_LOGS,
  PAGE_POS_API_LOGS,
  PAGE_FTP_CREATION_LOGS,
  PAGE_AGGREGATOR_API_LOG,
  PAGE_IMPORT_LOGS,
  PAGE_SMART_OOS,
  PAGE_INVENTORY,
  PAGE_AGGREGATOR_MANAGEMENT,
  PAGE_FTP_PROFILE,
  PAGE_ADD_FTP_PROFILE,
  PAGE_UPDATE_FTP_PROFILE,
  PAGE_PRICING,
  PAGE_CONFIG,
  PAGE_ADD_USER,
  PAGE_UPDATE_USER,
  PAGE_FORGOT_PASSWORD,
  PAGE_RESET_PASSWORD,
  PAGE_PRICING_UPDATE,
  PAGE_MASTER_DATA_UPDATE,
  PAGE_INVENTORY_UPDATE,
  PAGE_ADD_AGGREGATOR,
  PAGE_UPDATE_AGGREGATOR,
  PAGE_EXPORT_LOGS,
  PAGE_ADD_STORE,
  PAGE_UPDATE_STORE,
  PAGE_ADMIN_ORDERS,
  PAGE_ADMIN_ORDERS_DETAILS,
  // PAGE_STORE_ORDERS,
  PAGE_ORDERS_LOGS,
  PAGE_RECONCILIATION_LOGS,
  PAGE_PARTIAL_RMA,
  PAGE_RMA_DETAILS,
  PAGE_AREAS_MAPPING_MANAGEMENT,
  PAGE_PICKER_EMP_MAP,
  PAGE_POS_CONFIG,
  PAGE_TALON_LOGS,
  COST_MANAGEMENT,
  PAGE_SAP_LOGS,
  PAGE_ECOM_PRICING_DATA,
  PAGE_DELIVEROO_SYNC_LOGS,
  PAGE_POS_AREAS_MAPPING_MANAGEMENT,
  PAGE_INVENTORY_STOCK_CHECKER,
  PAGE_FOC_ORDER_LIST,
  PAGE_ADD_FOC_ORDER,
  PAGE_CHAIN_MGMT,
  PAGE_ADD_CHAIN,
  PAGE_UPDATE_CHAIN,
  PAGE_CLONE_INVENTORY_PRICE,
  PAGE_TALABAT_CONFIG,
  PAGE_TALABAT_LOGS,
  PAGE_PRICE_LABEL,
  PAGE_PRICE_LABEL_REPORT,
  PAGE_STOCK_OUT_REPORT,
  PAGE_PRICE_LABEL_SYNC_HISTORY,
  PAGE_NEW_SAP_BARCODE,
  PAGE_POS_OPEN_ORDERS,
  PAGE_POS_OPEN_ORDERS_DETAILS,
  PAGE_CATALOGUE_ACTION_LOGS,
  PAGE_ADMIN_AUDIT_LOGS,
  PAGE_TIME_STAMP_RESET,
  PAGE_PENDING_ERP_SYNC_ORDER,
  PAGE_PENDING_ERP_SYNC_RECON,
  PAGE_PENDING_ERP_SYNC_RMA,
  PAGE_APPROVER_MANAGER,
  PAGE_POWER_BI_CONFIG,
  PAGE_KDS_CONFIG,
  PAGE_ALERT_CONFIG,
  PAGE_MAGENTO_CONFIG,
  PAGE_INSTASHOP_LASTMILE_CONFIG,
  PAGE_ORDER_TRACKER_CONFIG,
  PAGE_POWER_BI_SYNC_LOGS,
  PAGE_KDS_SYNC_LOGS,
  PAGE_LAST_MILE_LOGS,
  PAGE_GENERIC_LOGS,
  PAGE_CRON_JOBS,
  PAGE_SERVER_ERROR,
  PAGE_PURCHASE_TIMER,
  PAGE_PURCHASE_TIMER_ADD,
  PAGE_PURCHASE_TIMER_UPDATE,
  PAGE_ADD_PRODUCT,
  PAGE_FRESH_CATEGORY,
  PAGE_FRESH_MANDATORY_BARCODE,
  PAGE_FRESH_REPORTS,
  PAGE_FRESH_CATEGORY_ADD,
  PAGE_FRESH_CATEGORY_UPDATE,
} from 'utils/constants'

import {
  AggregatorsManagement,
  Configurations,
  Dashboard,
  ForgotPassword,
  FtpProfiles,
  FunctionAndJobs,
  Inventory,
  Pricing,
  UpdatePricing,
  AggregatorApi,
  ErpApi,
  FtpCreation,
  ImportLog,
  PosApi,
  Login,
  MasterData,
  NotFound,
  SmartOOS,
  StoreManagement,
  UserManagement,
  AddUser,
  MasterDataUpdate,
  CreatePassword,
  UpdateInventory,
  CreateAggregator,
  UpdateAggregator,
  CreateStorePage,
  UpdateStorePage,
  CreateFtpProfile,
  UpdateFtpProfile,
  OrderListPage,
  OrderDetailsPage,
  // OrdersByStorePage,
  RmaDetailsPage,
  AreaManagement,
  CostManagement,
  EcomPricing,
  EcomPricingDetail,
  FocOrderList,
  CreateFocOrder,
  FocOrderDetail,
  ChainManagement,
  CreateChainPage,
  UpdateChainPage,
  CloneInventoryPrice,
  ServerError,
} from 'pages'
import MainLayout from 'layout/mainLayout'
import PageAccessWrapper from 'components/pageAccessWrapper'
import CronJobs from 'pages/cronJobs'
import LogoLayout from 'layout/logoLayout'
import ExportLog from 'pages/logPages/exportLog'
import OrdersLog from 'pages/logPages/ordersLog'
import ReconciliationLog from 'pages/logPages/reconciliationLog'
import PartialRmaPage from 'pages/orderManagement/partialRmaPage'
import UpdateUser from 'pages/userManagement/updateUser'
import { PickerEmpMapPage } from 'pages/pickerEmpMapManagement'
import PosConfiguration from 'pages/posConfiguration'
import TalonLog from 'pages/logPages/talonLog'
import SapLogs from 'pages/logPages/sapLogs'
import DeliverooSyncLog from 'pages/logPages/deliverooSyncLog'
import PosAreasManagement from 'pages/posAreasManagement'
import InventoryStockChecker from 'pages/InventoryStockChecker'
import TalabatConfigurations from 'pages/talabatConfigurations'
import PowerBiConfigurations from 'pages/powerBiConfigurations'
import KdsConfigurations from 'pages/kdsConfigurations'
import AlertConfigurations from 'pages/alertConfigurations'
import MagentoConfigurations from 'pages/magentoConfigurations'
import InstashopLastmileConfigurations from 'pages/instashopLastmileConfigurations'
import OrderTrackerConfigurations from 'pages/orderTrackerConfigurations'
import TalabatLogs from 'pages/logPages/talabatLogs'
import PriceLabelListPage from 'pages/priceLabel'
import PriceLabelReportPage from 'pages/priceLabelReport'
import PriceLabelSyncHistoryPage from 'pages/priceLabelSyncHistory'
import NewSapBarcodePage from 'pages/newSapBarcode'
import StockOutReportPage from 'pages/stockOutReport'
import { OpenOrderListPage } from 'pages/posOpenOrderManagement'
import OpenOrderDetailsPage from 'pages/posOpenOrderManagement/openOrderDetailPage'
import CatalogueActionLog from 'pages/logPages/catalogueAction'
import PowerBiSyncLog from 'pages/logPages/powerBiSyncLog'
import KdsSyncLog from 'pages/logPages/kdsSyncLog'
import LastMileLog from 'pages/logPages/lastMileLog'
import GenericLogs from 'pages/logPages/genericLogs'
import AdminAuditLogs from 'pages/logPages/adminAuditLogs'
import TimestampResetPage from 'pages/timestampReset/timestampResetPage'
import PendingErpSyncOrders from 'pages/pendingErpSync/pendingErpSyncOrders'
import PendingErpSyncRma from 'pages/pendingErpSync/pendingErpSyncRma'
import PendingErpSyncRecon from 'pages/pendingErpSync/pendingErpSyncRecon'
import ApproverManagersConfigurations from 'pages/approverManagersConfigurations'
import {
  PurchaseTimerListPage,
  PurchaseTimerAddPage,
  PurchaseTimerUpdatePage,
} from 'pages/purchaseTimer'
import { CreateBundleProduct, BundleProductList } from 'pages/bundleProduct'
import { FreshMandatoryBarcodeList } from 'pages/freshMandatoryBarcode'
import FreshReportPage from 'pages/freshReport'
import {
  FreshCategoryList,
  CreateFreshCategory,
  UpdateFreshCategory,
} from 'pages/freshCategory'

const RoutesProvider = () => {
  return (
    <Routes>
      {/*//* PUBLIC PAGE */}
      <Route element={<LogoLayout />}>
        <Route path={PAGE_LOGIN.path} element={<Login />} />
        <Route path={PAGE_FORGOT_PASSWORD.path} element={<ForgotPassword />} />
        <Route
          path={`${PAGE_RESET_PASSWORD.path}/:id`}
          element={<CreatePassword />}
        />
      </Route>

      <Route element={<MainLayout />}>
        {/* //! PERMISSION BASED PAGES */}
        <Route element={<PageAccessWrapper />}>
          <Route path={PAGE_DASHBOARD.path} element={<Dashboard />} />

          {/* User Management */}
          <Route path={PAGE_USER_MGMT.path} element={<UserManagement />} />

          <Route path={PAGE_MASTER_DATA.path} element={<MasterData />} />
          <Route
            path={PAGE_BUNDLE_PRODUCT.path}
            element={<BundleProductList />}
          />
          <Route path={PAGE_ECOM_PRICING_DATA.path} element={<EcomPricing />} />

          <Route path={PAGE_STORE_MGMT.path} element={<StoreManagement />} />

          {/* Logs */}
          <Route path={PAGE_ERP_API_LOGS.path} element={<ErpApi />} />
          <Route path={PAGE_SAP_LOGS.path} element={<SapLogs />} />
          <Route
            path={PAGE_ADMIN_AUDIT_LOGS.path}
            element={<AdminAuditLogs />}
          />
          <Route path={PAGE_POS_API_LOGS.path} element={<PosApi />} />
          <Route path={PAGE_FTP_CREATION_LOGS.path} element={<FtpCreation />} />
          <Route path={PAGE_IMPORT_LOGS.path} element={<ImportLog />} />
          <Route path={PAGE_EXPORT_LOGS.path} element={<ExportLog />} />
          <Route path={PAGE_ORDERS_LOGS.path} element={<OrdersLog />} />
          <Route
            path={PAGE_DELIVEROO_SYNC_LOGS.path}
            element={<DeliverooSyncLog />}
          />
          <Route
            path={PAGE_RECONCILIATION_LOGS.path}
            element={<ReconciliationLog />}
          />
          <Route path={PAGE_TALON_LOGS.path} element={<TalonLog />} />
          <Route
            path={PAGE_AGGREGATOR_API_LOG.path}
            element={<AggregatorApi />}
          />
          <Route path={PAGE_TALABAT_LOGS.path} element={<TalabatLogs />} />

          <Route
            path={PAGE_CATALOGUE_ACTION_LOGS.path}
            element={<CatalogueActionLog />}
          />
          <Route
            path={PAGE_POWER_BI_SYNC_LOGS.path}
            element={<PowerBiSyncLog />}
          />
          <Route path={PAGE_KDS_SYNC_LOGS.path} element={<KdsSyncLog />} />
          <Route path={PAGE_LAST_MILE_LOGS.path} element={<LastMileLog />} />
          <Route path={PAGE_GENERIC_LOGS.path} element={<GenericLogs />} />
          <Route path={PAGE_CRON_JOBS.path} element={<CronJobs />} />

          <Route path={PAGE_SMART_OOS.path} element={<SmartOOS />} />
          <Route path={PAGE_INVENTORY.path} element={<Inventory />} />
          <Route
            path={PAGE_AGGREGATOR_MANAGEMENT.path}
            element={<AggregatorsManagement />}
          />
          <Route path={PAGE_FTP_PROFILE.path} element={<FtpProfiles />} />
          <Route path={PAGE_PRICING.path} element={<Pricing />} />

          <Route
            path={PAGE_PRICE_LABEL.path}
            element={<PriceLabelListPage />}
          />

          <Route
            path={PAGE_PRICE_LABEL_SYNC_HISTORY.path}
            element={<PriceLabelSyncHistoryPage />}
          />

          <Route
            path={PAGE_PRICE_LABEL_REPORT.path}
            element={<PriceLabelReportPage />}
          />

          <Route
            path={PAGE_NEW_SAP_BARCODE.path}
            element={<NewSapBarcodePage />}
          />

          <Route
            path={PAGE_STOCK_OUT_REPORT.path}
            element={<StockOutReportPage />}
          />

          {/* Order Management */}
          <Route path={PAGE_ADMIN_ORDERS.path} element={<OrderListPage />} />

          <Route
            path={`${PAGE_ADMIN_ORDERS_DETAILS.path}/:orderId`}
            element={<OrderDetailsPage />}
          />

          {/* POS Open Order Management */}
          <Route
            path={PAGE_POS_OPEN_ORDERS.path}
            element={<OpenOrderListPage />}
          />

          <Route
            path={`${PAGE_POS_OPEN_ORDERS_DETAILS.path}/:orderId`}
            element={<OpenOrderDetailsPage />}
          />

          <Route
            path={`${PAGE_RMA_DETAILS.path}/:rmaId`}
            element={<RmaDetailsPage />}
          />
          <Route
            path={PAGE_AREAS_MAPPING_MANAGEMENT.path}
            element={<AreaManagement />}
          />
          <Route
            path={PAGE_POS_AREAS_MAPPING_MANAGEMENT.path}
            element={<PosAreasManagement />}
          />
          <Route path={COST_MANAGEMENT.path} element={<CostManagement />} />
          <Route
            path={PAGE_INVENTORY_STOCK_CHECKER.path}
            element={<InventoryStockChecker />}
          />

          <Route
            path={PAGE_PICKER_EMP_MAP.path}
            element={<PickerEmpMapPage />}
          />

          <Route
            path={PAGE_CLONE_INVENTORY_PRICE.path}
            element={<CloneInventoryPrice />}
          />

          {/* <Route
            path={PAGE_STORE_ORDERS.path}
            element={<OrdersByStorePage />}
          /> */}

          <Route
            path={PAGE_PENDING_ERP_SYNC_ORDER.path}
            element={<PendingErpSyncOrders />}
          />
          <Route
            path={PAGE_PENDING_ERP_SYNC_RMA.path}
            element={<PendingErpSyncRma />}
          />
          <Route
            path={PAGE_PENDING_ERP_SYNC_RECON.path}
            element={<PendingErpSyncRecon />}
          />

          <Route path={PAGE_FOC_ORDER_LIST.path} element={<FocOrderList />} />
          <Route path={PAGE_ADD_FOC_ORDER.path} element={<CreateFocOrder />} />
          <Route
            path={`${PAGE_FOC_ORDER_LIST.path}/:orderId`}
            element={<FocOrderDetail />}
          />

          {/* Chain Management */}
          <Route path={PAGE_CHAIN_MGMT.path} element={<ChainManagement />} />

          <Route
            path={PAGE_TIME_STAMP_RESET.path}
            element={<TimestampResetPage />}
          />

          {/* Purchase Timer */}
          <Route
            path={PAGE_PURCHASE_TIMER.path}
            element={<PurchaseTimerListPage />}
          />

          {/* Fresh Category */}
          <Route
            path={PAGE_FRESH_CATEGORY.path}
            element={<FreshCategoryList />}
          />
        </Route>

        {/* //* EDITOR ROUTES */}
        <Route element={<PageAccessWrapper checkEditAccess />}>
          <Route path={PAGE_CONFIG.path} element={<Configurations />} />
          <Route
            path={PAGE_TALABAT_CONFIG.path}
            element={<TalabatConfigurations />}
          />

          <Route
            path={PAGE_FRESH_MANDATORY_BARCODE.path}
            element={<FreshMandatoryBarcodeList />}
          />
        </Route>

        {/* //* EDITOR ROUTES */}
        <Route element={<PageAccessWrapper checkEditAccess />}>
          <Route path={PAGE_CONFIG.path} element={<Configurations />} />
          <Route
            path={PAGE_TALABAT_CONFIG.path}
            element={<TalabatConfigurations />}
          />

          <Route path={PAGE_FRESH_REPORTS.path} element={<FreshReportPage />} />
        </Route>

        {/* //* EDITOR ROUTES */}
        <Route element={<PageAccessWrapper checkEditAccess />}>
          <Route path={PAGE_CONFIG.path} element={<Configurations />} />
          <Route
            path={PAGE_TALABAT_CONFIG.path}
            element={<TalabatConfigurations />}
          />
          <Route
            path={PAGE_POWER_BI_CONFIG.path}
            element={<PowerBiConfigurations />}
          />
          <Route path={PAGE_KDS_CONFIG.path} element={<KdsConfigurations />} />
          <Route
            path={PAGE_ALERT_CONFIG.path}
            element={<AlertConfigurations />}
          />
          <Route
            path={PAGE_MAGENTO_CONFIG.path}
            element={<MagentoConfigurations />}
          />
          <Route
            path={PAGE_INSTASHOP_LASTMILE_CONFIG.path}
            element={<InstashopLastmileConfigurations />}
          />
          <Route
            path={PAGE_ORDER_TRACKER_CONFIG.path}
            element={<OrderTrackerConfigurations />}
          />
          <Route
            path={PAGE_APPROVER_MANAGER.path}
            element={<ApproverManagersConfigurations />}
          />
          <Route path={PAGE_POS_CONFIG.path} element={<PosConfiguration />} />

          <Route path={PAGE_FUNC_JOBS.path} element={<FunctionAndJobs />} />

          {/* User Management */}
          <Route path={PAGE_ADD_USER.path} element={<AddUser />} />
          <Route
            path={`${PAGE_UPDATE_USER.path}/:id`}
            element={<UpdateUser />}
          />

          {/* Master Data */}
          <Route
            path={`${PAGE_MASTER_DATA_UPDATE.path}/:id`}
            element={<MasterDataUpdate />}
          />

          {/* Bundle Product */}
          <Route
            path={PAGE_ADD_PRODUCT.path}
            element={<CreateBundleProduct />}
          />

          {/* Inventory Page */}
          <Route
            path={`${PAGE_INVENTORY_UPDATE.path}/:id`}
            element={<UpdateInventory />}
          />

          {/* Pricing Page */}
          <Route
            path={`${PAGE_PRICING_UPDATE.path}/:id`}
            element={<UpdatePricing />}
          />

          {/*ECom Pricing Page */}
          <Route
            path={`${PAGE_ECOM_PRICING_DATA.path}/:id`}
            element={<EcomPricingDetail />}
          />

          {/* Aggregator Page */}
          <Route
            path={`${PAGE_ADD_AGGREGATOR.path}`}
            element={<CreateAggregator />}
          />

          <Route
            path={`${PAGE_UPDATE_AGGREGATOR.path}/:id`}
            element={<UpdateAggregator />}
          />

          {/* Store Page */}
          <Route
            path={`${PAGE_ADD_STORE.path}`}
            element={<CreateStorePage />}
          />

          <Route
            path={`${PAGE_UPDATE_STORE.path}/:id`}
            element={<UpdateStorePage />}
          />

          {/* FTP Profile Page */}
          <Route
            path={`${PAGE_ADD_FTP_PROFILE.path}`}
            element={<CreateFtpProfile />}
          />

          <Route
            path={`${PAGE_UPDATE_FTP_PROFILE.path}/:id`}
            element={<UpdateFtpProfile />}
          />

          {/* Order Management */}
          <Route
            path={`${PAGE_PARTIAL_RMA.path}/:orderId/generate`}
            element={<PartialRmaPage />}
          />

          {/* Chain Management - Editor Routes */}
          <Route path={PAGE_ADD_CHAIN.path} element={<CreateChainPage />} />
          <Route
            path={`${PAGE_UPDATE_CHAIN.path}/:id`}
            element={<UpdateChainPage />}
          />

          {/* Purchase Timer - Editor Routes */}
          <Route
            path={PAGE_PURCHASE_TIMER_ADD.path}
            element={<PurchaseTimerAddPage />}
          />
          <Route
            path={`${PAGE_PURCHASE_TIMER_UPDATE.path}/:id`}
            element={<PurchaseTimerUpdatePage />}
          />

          {/* Fresh Category - Editor Routes */}
          <Route
            path={PAGE_FRESH_CATEGORY_ADD.path}
            element={<CreateFreshCategory />}
          />
          <Route
            path={`${PAGE_FRESH_CATEGORY_UPDATE.path}/:id`}
            element={<UpdateFreshCategory />}
          />
        </Route>
      </Route>

      {/* //! PAGE NOT FOUND  */}
      <Route path={PAGE_NOT_FOUND.path} element={<NotFound />} />
      <Route path={PAGE_SERVER_ERROR.path} element={<ServerError />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default RoutesProvider
